import React from "react";
import IconAndTextButton from "../Atoms/Buttons/IconAndTextButton";
import { useLocation, useNavigate } from "react-router-dom";
import backIcon from "../../assets/Arrow.svg";

const BackBtnHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();

  if (
    location.pathname === "/agents" ||
    location.pathname === "/solutions" ||
    location.pathname === "/" ||
    location.pathname === "/not-authorize" ||
    location.pathname === "/settings"
  ) {
    return null; // Don't render the back button on the login page
  }
  return (
    <section className="marketplace-back-btn-hdr">
      <div className="reg-edit-agent-back-btn">
        <IconAndTextButton
          icon={<img src={backIcon} alt="back" />}
          text="Back"
          iconPos="left"
          iconStyles={{
            width: 20,
            height: 20,
            display: "flex",
            alignItems: "center",
          }}
          clsNames="mas-secondary-btn-2 mas-btn-lg"
          textStyles={{
            color: "var(--db-secondary-gray-ten)",
          }}
          onClickFn={() => {
            navigate(-1);
          }}
        />
      </div>
    </section>
  );
};

export default BackBtnHeader;
